import { gangtokInstance as http } from "./http-common";

const token = "";

const getFuelStatusGraph = (data) => {
  return http.post("fuelTankdata", data, {
    headers: { Authorization: "Bearer" + token },
  });
};

const getObtsCount = (type) => {
  return http.post(`obtsCount/GetObtsCount?type=${type}`, {
    headers: { Authorization: "Bearer" + token },
  });
};

const getNewOBTS = (type, loc_id) => {
  return http.post(
    `obtsForGangtok/GetObtsForGangtok?type=${type}&loc_id=${loc_id}`,
    {
      headers: { Authorization: "Bearer" + token },
    }
  );
};

const getChartDutyReport = (type) => {
  return http.post(`DutyCountReport/GetDutyCount?type=${type}`, {
    headers: { Authorization: "Bearer" + token },
  });
};

const GangtokService = {
  getFuelStatusGraph,
  getObtsCount,
  getNewOBTS,
  getChartDutyReport,
};

export default GangtokService;
